import React from "react";
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";

const Contact = () => {
  return (
    <section className="section-shell bg-primary px-5 py-20 md:px-8" id="contact">
      <div className="reveal-up reveal-delay-3 mx-auto w-full max-w-6xl">
        <div className="glass-panel rounded-3xl p-8 text-center text-white md:p-10">
          <p className="section-kicker mb-3">Contact</p>
          <h2 className="heading-font section-title text-3xl font-bold sm:text-4xl">Let&apos;s build something impactful</h2>
          <p className="mx-auto mt-4 max-w-2xl text-slate-300">
            Reach out for collaboration, platform engineering opportunities, or cloud security consulting discussions.
          </p>

          <div className="mt-8 flex items-center justify-center gap-6">
            <a
              href="https://www.linkedin.com/in/jeffrey-ck-lau/"
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-slate-400/35 bg-slate-900/30 p-3 text-slate-100 transition hover:-translate-y-1 hover:border-accent hover:text-accent"
              aria-label="LinkedIn profile"
            >
              <AiFillLinkedin size={28} />
            </a>
            <a
              href="https://github.com/jeffreylauck"
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-slate-400/35 bg-slate-900/30 p-3 text-slate-100 transition hover:-translate-y-1 hover:border-accent hover:text-accent"
              aria-label="GitHub profile"
            >
              <AiFillGithub size={28} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
